export default __webpack_public_path__ + "static/media/plan.500e8eb2.svg";